import React from 'react'
import '../styles/happyTears.css'

export const HappyTears = () => {
  return (
    <div className='marquee'><marquee><b>Happy Tears Surprises</b> is celebrating today 30/09/23, Birthday of the Founder/CEO <b>Nivesh K</b>, use code NIVESHK200 to avail a crazy discount of Rs. 200/- on selected Products*</marquee></div>
  )
}
